import React from "react";
import clsx from "clsx";
import { useIntl } from "react-intl";
import "./style.css";

function Loader({ variant = "page", classes, message, showMessage = true }) {
	const { formatMessage: trans } = useIntl();
	const label = message ?? trans({ id: "loading", defaultMessage: "Loading..." });

	return (
		<div
			className={clsx("loader-root", `loader-root--${variant}`, classes)}
			role="status"
			aria-live="polite"
			aria-busy="true"
			aria-label={label}
		>
			<div className="loader-content">
				<div className="loader-spinner" aria-hidden="true">
					<span className="loader-spinner__ring" />
					<span className="loader-spinner__ring loader-spinner__ring--accent" />
				</div>
				{showMessage && <p className="loader-message">{label}</p>}
			</div>
		</div>
	);
}

export { Loader };
